import { u as h } from "./use-product-y102e61c.js";
import { u as k, o as y, b, c as s, e as a, F as r, p as d, f as m, g as o, t as c, k as i, i as v } from "./define-element-XpjsV6s1.js";
import { _ as g } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const x = {
  class: "offset-product-list-options",
  ref: "container"
}, C = ["aria-expanded", "aria-controls", "onClick"], S = { key: 0 }, L = { key: 1 }, P = {
  key: 0,
  class: "offset-product-list-option-selected"
}, B = ["id"], N = ["checked", "onChange"], R = {
  __name: "ProductListOptions",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    }
  },
  setup(u) {
    const p = u, { options: _ } = h(), f = k("container");
    function l(n) {
      return "product-list-option-" + n.label.toLowerCase().replace(/[^a-z0-9]+/g, "-");
    }
    return y(() => {
      b(f.value, p.inheritStyle);
    }), (n, V) => (s(), a("div", x, [
      (s(!0), a(r, null, d(m(_), (t) => (s(), a("div", {
        key: t.label,
        class: "offset-product-list-option"
      }, [
        o("button", {
          type: "button",
          "aria-expanded": !t.collapsed,
          "aria-controls": l(t),
          onClick: (e) => t.collapsed = !t.collapsed
        }, [
          o("span", null, c(t.label), 1),
          t.collapsed ? (s(), a("span", S, "+")) : (s(), a("span", L, "−"))
        ], 8, C),
        t.options.some((e) => e.checked) ? (s(), a("div", P, c(t.options.filter((e) => e.checked).map((e) => e.label).join(", ")), 1)) : i("", !0),
        t.collapsed ? i("", !0) : (s(), a("div", {
          key: 1,
          id: l(t)
        }, [
          (s(!0), a(r, null, d(t.options, (e) => (s(), a("div", {
            key: e.label,
            class: "offset-product-list-option-item"
          }, [
            o("label", null, [
              o("input", {
                type: "checkbox",
                checked: e.checked,
                onChange: (w) => e.checked = !e.checked
              }, null, 40, N),
              v(" " + c(e.label) + " (" + c(e.count) + ") ", 1)
            ])
          ]))), 128))
        ], 8, B))
      ]))), 128))
    ], 512));
  }
}, $ = /* @__PURE__ */ g(R, [["__scopeId", "data-v-70c64a7b"]]);
export {
  $ as P
};
